import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-139">
      <div className="max-w-4xl mx-auto text-center" data-id="element-140">
        {/* Cost Table */}
        <h2 className="text-3xl sm:text-4xl font-black text-white mb-8" data-id="element-141">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
        <div className="bg-[#001a0d] border border-[#00C853]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-142">
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-[#000d08] border-b border-[#00C853]/30" data-id="element-143">
            <div className="p-4 font-bold text-gray-400 text-center" data-id="element-144">
              Sin MegaPack
            </div>
            <div className="p-4 font-bold text-[#00C853] text-center sm:border-l border-[#00C853]/30" data-id="element-145">
              Costo real
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-146">
            <div className="p-4 text-gray-400 text-sm" data-id="element-147">
              3 horas de planificación × 40 semanas
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00C853]/5 sm:border-l border-gray-800" data-id="element-148">
              120 horas de tu vida por año
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-149">
            <div className="p-4 text-gray-400 text-sm" data-id="element-150">
              Evaluaciones sin solucionario
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00C853]/5 sm:border-l border-gray-800" data-id="element-151">
              Fines de semana corrigiendo sin criterios claros
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-152">
            <div className="p-4 text-gray-400 text-sm" data-id="element-153">
              Material de inclusión improvisado
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00C853]/5 sm:border-l border-gray-800" data-id="element-154">
              Riesgo pedagógico + desgaste docente
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-155">
            <div className="p-4 text-gray-400 text-sm" data-id="element-156">
              Grupos con niveles mixtos sin sistema
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00C853]/5 sm:border-l border-gray-800" data-id="element-157">
              Estudiantes que se pierden y no vuelven
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-158">
            <div className="p-4 text-gray-400 text-sm" data-id="element-159">
              Buscando en internet cada domingo
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00C853]/5 sm:border-l border-gray-800" data-id="element-160">
              El mismo ciclo — el año que viene, y el siguiente
            </div>
          </div>
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3 italic" data-id="element-161">
          El próximo domingo puede ser diferente.
        </h2>
        <p className="text-[#00C853] text-xl sm:text-2xl font-black mb-10 italic" data-id="element-162">
          &quot;Il prossimo domenico può essere diverso.&quot; 🇮🇹
        </p>

        {/* Countdown */}
        <div className="mb-10" data-id="element-163">
          <p className="text-white font-bold mb-4 text-xl" data-id="element-164">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-165" />
        </div>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-166">
          <div className="bg-[#0a0a0a] border border-[#00C853]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-167">
            <div className="text-2xl mb-2" data-id="element-168">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-169">MEGAPACK ITALIANO</h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-170">
              6 Tomos + 6 Bonos · Todos los niveles
            </p>
            <div className="mt-auto" data-id="element-171">
              <div className="text-gray-400 line-through text-sm mb-1" data-id="element-172">
                $45 USD
              </div>
              <p className="text-[#00C853] text-2xl font-black mb-2" data-id="element-173">
                $13.90 USD
              </p>
              <p className="text-gray-500 text-[10px] italic mb-4" data-id="element-174">
                💬 Pagarás en la moneda de tu país al momento del pago
              </p>
              <a href="https://docentes2.edulabs.online/cart/43244882493558:1" className="btn-green-pulse block bg-[#00C853] text-black font-black py-4 rounded-lg hover:bg-[#00E676] transition-colors text-sm" data-id="element-175">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#000d08] border-2 border-[#00C853] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(0,200,83,0.2)] flex flex-col" data-id="element-176">
            <div className="text-2xl mb-2" data-id="element-177">🏆</div>
            <h3 className="text-[#00C853] font-black mb-1" data-id="element-178">
              MEGAPACK + ADAPTACIONES ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-179">
              6 Tomos + 6 Bonos + Kit de Inclusión Completo
            </p>
            <div className="mt-auto" data-id="element-180">
              <div className="text-gray-400 line-through text-sm mb-1" data-id="element-181">
                $65 USD
              </div>
              <p className="text-[#00C853] text-3xl font-black mb-2" data-id="element-182">
                $19.90 USD
              </p>
              <p className="text-gray-500 text-[10px] italic mb-4" data-id="element-183">
                💬 Pagarás en la moneda de tu país al momento del pago
              </p>
              <a href="https://docentes2.edulabs.online/cart/43244882657398:1" className="btn-green-pulse block bg-[#00C853] text-black font-black py-4 rounded-lg hover:bg-[#00E676] transition-colors text-sm" data-id="element-184">
                → QUIERO EL MEGAPACK + ADAPTACIONES
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-185">
          <span data-id="element-186">🔒 Pago 100% seguro</span>
          <span data-id="element-187">⚡ Acceso en 5 minutos</span>
          <span data-id="element-188">🛡️ Garantía 7 días</span>
          <span data-id="element-189">💳 Todas las tarjetas</span>
        </div>
      </div>
    </section>;
}